import Tab from 'bootstrap/js/dist/tab';
import Popover from 'bootstrap/js/dist/popover';
import "./floorplan.js";
import merge from 'lodash.merge';

const availTabs = document.getElementById('availability-tabs');

if (availTabs) {
  const activeTabInput = availTabs.querySelector('[name="activeTab"]');

  availTabs.addEventListener('show.bs.tab', (event) => {
    let navItems = availTabs.querySelectorAll('.nav-item');
    let clickedNavItem = event.target.closest('.nav-item');
    let buttonIndex = [...navItems].indexOf(clickedNavItem);

    if (activeTabInput && buttonIndex >= 0) {
      activeTabInput.value = buttonIndex;
    }

    if (openPopper) {
      openPopper.hide();
    }
  })

  // hide property map tab when smaller than tablet
  const mediaQuery = window.matchMedia(`(max-width: 767.98px)`);
  const firstTabElem = availTabs.querySelector('.nav-link');

  if (firstTabElem) {
    const firstTab = Tab.getOrCreateInstance(firstTabElem);

    function handleMobileChange(e) {
      if (e.matches) {
        firstTab.show();

        if (activeTabInput) {
          activeTabInput.value = 0;
        }
      }
    }
    // Register event listener
    mediaQuery.addEventListener('change', handleMobileChange);

    // Initial check
    handleMobileChange(mediaQuery);
  }
}

const tourModal = document.getElementById('tour-modal');

if (tourModal) {
  let openTourModal;
  let tourModalContent = tourModal.querySelector('#tour-modal-content');

  tourModal.addEventListener('show.bs.modal', (event) => {
    let clickedElem = event.relatedTarget;
    let entryId = clickedElem.getAttribute('data-entry-id');

    if (openTourModal !== entryId) {
      let modalTitle = tourModal.querySelector('.modal-title');
      let hiddenInput = tourModal.querySelector('[name="entryId"]');

      modalTitle.textContent = clickedElem.getAttribute('data-title');
      hiddenInput.value = entryId;
      tourModalContent.dispatchEvent(new Event('refresh'));
      openTourModal = entryId;
    }
  })
}

const unitTypeInput = availTabs.querySelector('#availability-filter [name="unitType"]');
let propertyMapInput = availTabs.querySelector('#input-property-map-unit-type');

function initPropertyMapInput(input) {
  input.addEventListener('change', () => {
    unitTypeInput.value = input.value;
    unitTypeInput.dispatchEvent(new Event('change'));
  })
}

if (propertyMapInput && unitTypeInput) {
  initPropertyMapInput(propertyMapInput);
}

availTabs.addEventListener('htmx:afterSwap', () => {
  propertyMapInput = availTabs.querySelector('#input-property-map-unit-type');

  if (propertyMapInput && unitTypeInput) {
    initPropertyMapInput(propertyMapInput);
  }
});


// Property Map

const xmlns = "http://www.w3.org/2000/svg";
let propertyMapSvg;
let openPopper;

function initPropertyMap(svg) {
  openPopper = null;
  const mapData = __MAP_DATA__;

  mapData.forEach((location) => {
    let svgElem = svg.querySelector(`#${location.mapLocation}`);

    if (svgElem) {
      let mapLink = document.createElementNS(xmlns, 'a');
      mapLink.setAttributeNS(null, 'class', 'property-map-link');
      mapLink.setAttributeNS(null, 'href', '#');
      mapLink.setAttributeNS(null, 'tabindex', '0');
      mapLink.setAttributeNS(null, 'role', 'button');
      svgElem.parentNode.insertBefore(mapLink, svgElem);
      mapLink.appendChild(svgElem);
      mapLink.addEventListener('click', function (event) {
        event.preventDefault();
      })

      const customAllowList = Popover.Default.allowList;
      customAllowList.a = ['target', 'href', 'title', 'rel', 'class', 'data-bs-toggle', 'data-entry-id', 'data-title'];

      let popoverContent = "";
      let floorplans = location.floorplans;
      floorplans.forEach((item) => {
        popoverContent += `
          <div class="popover-item">
            <div class="popover-eyebrow">Available</div>
            <a class="property-map-modal-toggle" href="#availability-modal-${location.mapLocation}-${item.floorplan}-map" role="button" data-bs-toggle="modal">
              <h3 class="popover-item-header">${item.units}</h3>
            </a>
            <div class="popover-item-content lining-nums">
              ${item.bedsBaths}<br>
              ${item.priceRange}
            </div>
          </div>
        `
      })

      const popover = new Popover(mapLink, {
        allowList: customAllowList,
        customClass: 'property-map-popover',
        html: true,
        placement: 'top',
        fallbackPlacements: ['top','bottom'],
        content: popoverContent,
        template: `<div class="popover" role="popover"><div class="popover-arrow"></div><div class="popover-body"></div></div>`,
        trigger: 'click',
        popperConfig(defaultBsPopperConfig) {
          const newPopperConfig = {modifiers: [
            {
              name: 'flip',
              options: {
                padding: { top: 124 },
              },
            },
          ]}

          merge(newPopperConfig, defaultBsPopperConfig)
          return newPopperConfig;
        }
      })
    }
  });
}

availTabs.addEventListener('htmx:afterSettle', () => {
  propertyMapSvg = availTabs.querySelector('.property-map svg');

  if (propertyMapSvg) {
    initPropertyMap(propertyMapSvg);
  }
});

propertyMapSvg = availTabs.querySelector('.property-map svg');
if (propertyMapSvg) {
  initPropertyMap(propertyMapSvg);
}

availTabs.addEventListener('show.bs.popover', (event) => {
  if (openPopper) {
    openPopper.hide();
  }
  openPopper = Popover.getOrCreateInstance(event.target);
})

availTabs.addEventListener('hide.bs.popover', (event) => {
  if (openPopper) {
    openPopper = null;
  }
})

availTabs.addEventListener('htmx:beforeRequest', () => {
  if (openPopper) {
    openPopper.hide();
  }
})
